import React, { useState, useEffect } from "react";
import { FiChevronRight } from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";
import { menuRoutes } from "../config/menuRoutes.js";
import "../assets/css/Sidebar.css";

export default function Sidebar({ setActiveNav, collapsed }) {
  const navigate = useNavigate();
  const location = useLocation();

  const [sidebarWidth, setSidebarWidth] = useState(240);

  useEffect(() => {
    setSidebarWidth(collapsed ? 60 : 240);
  }, [collapsed]);

  // Helper to decide which menu is active
 const isActive = (item) => {
  const currentPath = location.pathname;

  // Exact match
  if (currentPath === item.path) return true;

  // Related paths (Dashboard → analytics, daily-data-table)
  if (item.relatedPaths?.some((path) => currentPath.startsWith(path))) {
    return true;
  }

  if (item.matchNested && currentPath.startsWith(item.path)) {
    const hasMoreSpecificMatch = menuRoutes.some(
      (route) =>
        route.path !== item.path &&
        currentPath.startsWith(route.path)
    );
    return !hasMoreSpecificMatch;
  }

  return false;
};

  return (
    <aside
      className={`sidebar ${collapsed ? "collapsed" : ""}`}
      style={{ width: `${sidebarWidth}px`, transition: "width 0.3s ease" }}
    >
      <div className="sidebar-header"></div>

      <nav>
        {menuRoutes.map((item) => (
          <button
            key={item.label}
            className={`nav-item ${isActive(item) ? "active" : ""}`}
            onClick={() => {
              setActiveNav(item.label);
              navigate(item.path);
            }}
          >
            <span className="nav-icon">{item.icon}</span>
            {!collapsed && <span className="nav-label">{item.label}</span>}
            {!collapsed && item.submenu && (
              <FiChevronRight className="submenu-icon" />
            )}
          </button>
        ))}
      </nav>
    </aside>
  );
}
